module.exports = __webpack_public_path__ + "img/mirror-ribbon.f44cc0f4.png";